import { render, staticRenderFns } from "./twitterFeed.vue?vue&type=template&id=828809a2&scoped=true"
import script from "./twitterFeed.vue?vue&type=script&lang=js"
export * from "./twitterFeed.vue?vue&type=script&lang=js"
import style0 from "./twitterFeed.vue?vue&type=style&index=0&id=828809a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828809a2",
  null
  
)

export default component.exports